import { render, staticRenderFns } from "./PageEdit.vue?vue&type=template&id=3ae04a91&scoped=true"
import script from "./PageEdit.vue?vue&type=script&lang=js"
export * from "./PageEdit.vue?vue&type=script&lang=js"
import style0 from "./PageEdit.vue?vue&type=style&index=0&id=3ae04a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae04a91",
  null
  
)

export default component.exports